var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDraftFilled = function SvgDraftFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    fillRule: "evenodd",
    d: "M17 13.152A4.5 4.5 0 0 0 12.016 18H5a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v9.152Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    d: "m17 13.152-.083.746a.75.75 0 0 0 .605-.208L17 13.152ZM12.015 18v.75a.75.75 0 0 0 .748-.812l-.748.062ZM17 13.152l.523.538a.75.75 0 0 0 .227-.538H17Zm.082-.745a5.282 5.282 0 0 0-.582-.032v1.5c.141 0 .28.008.417.023l.165-1.491Zm-.582-.032a5.25 5.25 0 0 0-5.25 5.25h1.5a3.75 3.75 0 0 1 3.75-3.75v-1.5Zm-5.25 5.25c0 .147.006.293.018.437l1.495-.124a3.813 3.813 0 0 1-.013-.313h-1.5Zm.765-.375H5v1.5h7.015v-1.5ZM5 17.25c-.69 0-1.25-.56-1.25-1.25h-1.5A2.75 2.75 0 0 0 5 18.75v-1.5ZM3.75 16V4h-1.5v12h1.5Zm0-12c0-.69.56-1.25 1.25-1.25v-1.5A2.75 2.75 0 0 0 2.25 4h1.5ZM5 2.75h10v-1.5H5v1.5Zm10 0c.69 0 1.25.56 1.25 1.25h1.5A2.75 2.75 0 0 0 15 1.25v1.5ZM16.25 4v9.152h1.5V4h-1.5Zm.227 8.614 1.045 1.076-1.045-1.076Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M5.25 6.18A.75.75 0 0 1 6 5.43h8a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75Zm0 3.32A.75.75 0 0 1 6 8.75h8a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75Zm.8 2.75a.75.75 0 0 0 0 1.5H10a.75.75 0 0 0 0-1.5H6.05Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    fillRule: "evenodd",
    d: "M16.5 12.375a5.25 5.25 0 1 0 0 10.5 5.25 5.25 0 0 0 0-10.5Zm-3.75 5.25a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0Zm5-1.5a.75.75 0 0 0-1.5 0v1.125H15a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 .75-.75v-1.875Z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDraftFilled);
export default ForwardRef;